import React from 'react';
import './index.css';
import Carousel from 'react-image-carousel';

function What() {
    let images = [
        './images/fire1.jpg',
        './images/fire1.jpg',
        './images/fire1.jpg',
        './images/fire1.jpg',
        './images/fire1.jpg'
    ];
    return(
        <div className="what-container">
            <h3>What We Do</h3>
            <div className="what-divider"/>
            <div className="what-content">
                <div className="what-item">
                    <p className="single-p">Our Goal was to develop a method to perform the Annual Foam 
                    Proportioning Test. A method that would be approved through NFPA 
                    AND Factory Mutual approvals that would eliminate the environmental 
                    concerns of discarding Foam or Test Liquids This would eliminate the expense of flowing and replacing foam concentrate, and remove the cost of trucking and disposal of the foam concentrate. Allowing us to flow low, midrange and high range of the proportioner. </p>
                </div>
                <div className="what-item">
                    <iframe width="420" height="315" src="https://youtube.com/embed/j6n8v_guPy0"></iframe>
                </div>
            </div>
            <h3 id="what-two">Our Process</h3>
            <div className="what-divider"/>
            <div id="content-2" className="what-content">
                <div className="what-item">
                <Carousel width="300px;" images={images} 
                thumb={true}
                loop={true}/>
                </div>
                <div className="what-item">
                    <p>The method relies on an initial foam system discharge test to establish that the system is working properly and to determine the concentration the proportioner is developing. This test is conducted in the same fashion as any other foam proportioning system acceptance test. This test is immediately followed by a water equivalency test at the exact same conditions as the initial foam discharge test.</p>
                    <p>A water equivalency test essentially replaces the foam concentrate supply to the proportioner with water. The flowrate of the system and the flowrate of the water used in place of the concentrate are both measured with precision flow meters, and a baseline proportioning rate is established.</p>
                    <p>The proportioning system can then be tested in the future by repeating a water equivalency test and comparing the results to the initial water equivalency test. Flow of foam concentrate is not necessary. </p>
                </div>
            </div>
        </div>
    )
}
export default What;